import React, { useState,useContext } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Badge } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../context/actions/user";
import { useHistory } from "react-router-dom";
import './index.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faMoon } from '@fortawesome/free-solid-svg-icons';
import { capitalizeFirstLetter } from "../../../utils/common";
import UserPlaceholder from "../../../components/common/UserPlaceholder";
import { tempAction } from '../../../context/actions/tempAction';
import { resetReadOnlyDoc } from "../../../context/actions/document"
import { SocketContext } from "../../../context/actions/socket";
// import useDarkMode from 'use-dark-mode';

const SettingDropdown = (props) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const isAdmin = useSelector((state)=> state?.user?.user?.isAdminLoggedIn)
	const userDetail = useSelector((state) => state?.user?.user);
	const selectedFile = useSelector((state) => state.document.fileData);
	const { backendSocket } = useContext(SocketContext);
	const toggle = () => setDropdownOpen(prevState => !prevState);
	const openedWindow = useSelector(state => state?.document?.openedTab)
	// const darkMode = useDarkMode(false);

	const logOut = () => {
		// if(selectedFile?.reading_by === userDetail?._id && selectedFile?.read_only){
		// 	dispatch(resetReadOnlyDoc({ docId: selectedFile._id}, (result) => {
		// 		if(result){
		// 			backendSocket.emit('check-doc-status', selectedFile)
		// 			console.log(selectedFile._id," doc reset")
		// 		}
		// 	}))
		// }


		if(openedWindow && openedWindow?.length > 0){
			for(let i = 0; i < openedWindow?.length; i++ ){
				openedWindow[i].close()
			}
			dispatch({type: "OPENED_TAB", data: []})
		}
		
		dispatch(logout(() => {
			history.push("/")
		}));
	}

	const accountSetting = () => {
		// if(selectedFile?.reading_by === userDetail?._id && selectedFile?.read_only){
		// 	dispatch(resetReadOnlyDoc({ docId: selectedFile._id}, (result) => {
		// 		if(result){
		// 			backendSocket.emit('check-doc-status', selectedFile)
		// 			console.log(selectedFile._id," doc reset")
		// 		}
		// 	}))
		// }
		history.push('/account-setting')
	}

	return (
		<Dropdown isOpen={dropdownOpen} toggle={toggle} className='user-setting'>
			<DropdownToggle color='link' className='icon-btn d-flex align-items-center'>
				<span className='user-pic d-inline-flex rounded-circle'>
					{userDetail?.blob_name ?
						<img className='img-fluid w-100 h-100 rounded-circle' src={userDetail.blob_name} alt='User' />
						: <UserPlaceholder />
					}
				</span>
				<span className="info d-flex flex-column">
					<span className="ttl">
						{userDetail?.fname && capitalizeFirstLetter(userDetail?.fname) + ' ' + (userDetail?.lname && capitalizeFirstLetter(userDetail?.lname))}
						{/* <Badge color="primary">
							{userDetail?.current_subscription?.current_pan && userDetail?.current_subscription?.subscription_status === 'active' && capitalizeFirstLetter(userDetail?.current_subscription?.current_pan) || 'Free'}
						</Badge> */}
					</span>
					{/* <span>John@gmail.com</span> */}
					<span className='text'>{capitalizeFirstLetter(userDetail?.roles?.role?.roleName)}</span>
					<span className='text'>{userDetail?.organization_detail?.name?.length < 30 ? userDetail?.organization_detail?.name : userDetail?.organization_detail?.name?.slice(0, 20) + "..."} </span>
				</span>
			</DropdownToggle>
			<DropdownMenu>

				<DropdownItem onClick={() => accountSetting()}>
					<span className='icon d-inline-flex align-items-center'>
						<FontAwesomeIcon icon={faCog} />
					</span>
					Account Settings
				</DropdownItem>
				{/* <DropdownItem onClick={() => accountSetting()}>
					<span className='icon d-inline-flex align-items-center'>
						<FontAwesomeIcon icon={faMoon} />
					</span>
					Dark Mode
				</DropdownItem> */}
				<DropdownItem onClick={logOut}>
					<span className='icon d-inline-flex align-items-center'>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							fill="none"
							stroke="currentColor"
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							className="feather feather-log-out"
							viewBox="0 0 24 24"
						>
							<path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"></path>
							<path d="M16 17L21 12 16 7"></path>
							<path d="M21 12L9 12"></path>
						</svg>
					</span>
					Sign Out
				</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	);
}

export default SettingDropdown;
